import { useState } from "react";
import styled from "styled-components";

import normalInfoIcon from "../../../icons/normal-info-icon.svg";
import tealInfoIcon from "../../../icons/teal-info-icon.svg";
import CustomTooltip from "../tooltip/CustomTooltip";

const StyledSpan = styled.span`
  padding: 0.6px;
  display: flex;
  width: 16px;
  min-width: 16px;
  height: 16px;
  background-image: url(${(props) =>
    props.$active ? tealInfoIcon : normalInfoIcon});
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
`;

const IconWithTooltip = ({ label, onClick, placement = "top" }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <>
      <CustomTooltip text={label} placement={placement}>
        <StyledSpan
          $active={isActive}
          onMouseEnter={() => setIsActive(true)}
          onMouseLeave={() => setIsActive(false)}
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          onClick={onClick}
        ></StyledSpan>
      </CustomTooltip>
    </>
  );
};

export default IconWithTooltip;
